import veeValidate from '@/plugins/veeValidate.js';
import vuetifyPlugin from '@/plugins/vuetify.js';
import IdleVue from 'idle-vue';
import VueGoodTablePlugin from 'vue-good-table';
import Alerts from '@/components/utilities/Alerts.vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import ImageMagnifier from 'vue-image-magnifier';

export default {
  setupVuePlugins: function (vueInstance) {
    const vuetify = vuetifyPlugin.setup(vueInstance);
    vueInstance.use(Vuex);
    vueInstance.use(VueRouter);
    vueInstance.use(VueGoodTablePlugin);
    vueInstance.use(VueDOMPurifyHTML);
    veeValidate.setup(vueInstance);

    const eventsHub = new Vue();
    const timeoutMins = 30;

    vueInstance.use(IdleVue, {
      eventEmitter: eventsHub,
      idleTime: timeoutMins * 60000
    });

    vueInstance.use(ImageMagnifier);

    vueInstance.component('alerts', Alerts);

    vueInstance.config.productionTip = false;

    return {
      vuetify
    };
  }
};
